import React, { type FC } from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import {
	AccessRequestsTable,
	type AccessRequestsTableProps,
} from '@confluence/access-requests/entry-points/AccessRequestsTable.tsx';

import { useUsdLoadingHeight } from '../../useUsdLoadingHeight.ts';
import { SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE } from '../../../../controller/Controller.tsx';

export type AccessRequestsDialogBodyProps = Omit<
	AccessRequestsTableProps,
	'tryCacheFirst' | 'minLoadingHeight' | 'source'
> & {
	isInitialDialog: boolean;
	onAccessRequestsChange?: (hasChanges: boolean) => void;
};

const modalBodyHeightAdjustment = css({
	marginBottom: token('space.negative.025'),
});

export const AccessRequestsDialogBody: FC<AccessRequestsDialogBodyProps> = ({
	isInitialDialog,
	isBlockedAccessFlowActive,
	maybeStartBlockedAccessFlowForUser,
	onAccessRequestsChange,
}) => {
	const { accessRequestsLoadingHeight, modalBodyHasTopBottomPadding } = useUsdLoadingHeight();

	return (
		<div
			css={modalBodyHasTopBottomPadding && modalBodyHeightAdjustment}
			data-testid="access-requests-dialog-body"
		>
			<AccessRequestsTable
				tryCacheFirst={isInitialDialog}
				isBlockedAccessFlowActive={isBlockedAccessFlowActive}
				maybeStartBlockedAccessFlowForUser={maybeStartBlockedAccessFlowForUser}
				minLoadingHeight={accessRequestsLoadingHeight}
				source={SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE}
				onHasUnsavedChanges={onAccessRequestsChange}
			/>
		</div>
	);
};
